module.exports = __webpack_public_path__ + "img/四川天府新区第六小学.ecfbaa08.jpg";